import { render, staticRenderFns } from "./GeldImAlter.vue?vue&type=template&id=67e3e2a4&scoped=true"
import script from "./GeldImAlter.vue?vue&type=script&lang=js"
export * from "./GeldImAlter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3e2a4",
  null
  
)

export default component.exports